import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmation-task',
  templateUrl: './confirmation-task.component.html',
  styleUrls: ['./confirmation-task.component.scss']
})
export class ConfirmationTaskComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
